export const cropperAspectRatios = {
  profile_image: 1,
  banner: 21 / 9,
};

export const imageAspectRatios = {
  profile_image: '1:1',
  banner: '21:9',
};
